import { EventActionType } from './event-action-type';

export interface SetEventDescriptionAction {
  description: string;
  eventKey: string;
  type: EventActionType.SetEventDescription;
}

export const setEventDescription = (
  eventKey: string,
  description: string,
): SetEventDescriptionAction => ({
  description,
  eventKey,
  type: EventActionType.SetEventDescription,
});
